import axios from "../axios";

export const editUser = (data, id) => {
  return axios.post(`admin/user/${id}`, data, {
    headers: {
      "content-type": "multipart/form-data",
    },
  });
};
